import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { REVIEWS } from "../data/siteData";

export const ReviewSlider = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const t = setInterval(() => setIndex((i) => (i + 1) % REVIEWS.length), 4500);
    return () => clearInterval(t);
  }, [paused]);

  const go = (dir) =>
    setIndex((i) => (i + dir + REVIEWS.length) % REVIEWS.length);

  const review = REVIEWS[index];

  return (
    <div
      data-testid="review-slider"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="relative min-h-[240px] sm:min-h-[200px]">
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={index}
            data-testid={`review-slide-${index}`}
            initial={{ opacity: 0, x: 60 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -60 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="max-w-4xl font-display text-2xl font-light italic leading-snug text-stone-200 sm:text-3xl lg:text-4xl">
              “{review.quote}”
            </p>
            <footer className="mt-8 font-mono-alt text-[10px] uppercase tracking-[0.25em] text-amber-500/70">
              — {review.author} · {review.area}
            </footer>
          </motion.blockquote>
        </AnimatePresence>
      </div>

      <div className="mt-12 flex items-center gap-6">
        <button
          onClick={() => go(-1)}
          aria-label="Previous review"
          data-testid="review-prev-btn"
          className="flex h-11 w-11 items-center justify-center rounded-full border border-amber-500/30 text-amber-200 transition-all duration-300 hover:bg-amber-400 hover:text-[#0B0B0C]"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
        <button
          onClick={() => go(1)}
          aria-label="Next review"
          data-testid="review-next-btn"
          className="flex h-11 w-11 items-center justify-center rounded-full border border-amber-500/30 text-amber-200 transition-all duration-300 hover:bg-amber-400 hover:text-[#0B0B0C]"
        >
          <ArrowRight className="h-4 w-4" />
        </button>
        <div className="flex items-center gap-2.5" data-testid="review-dots">
          {REVIEWS.map((r, i) => (
            <button
              key={r.author}
              onClick={() => setIndex(i)}
              aria-label={`Go to review ${i + 1}`}
              data-testid={`review-dot-${i}`}
              className={`h-1.5 rounded-full transition-all duration-500 ${
                i === index ? "w-8 bg-amber-400" : "w-1.5 bg-stone-600 hover:bg-stone-400"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
